module.exports = __webpack_public_path__ + "9ec263601ee3fcd71763941207c9ad0d.ttf";